// extracted by mini-css-extract-plugin
module.exports = {"rootContainer":"DataLoadingIndicator_rootContainer__3dd7t"};